import React from 'react'
import Marquee from "react-fast-marquee";
import { getImages } from '../const';
import { Link } from 'react-router-dom';
import UseScrollReveal from '../Common/UseScrollReveal ';

const carData = [
    {
        image: 'fv-img1.jpg',
        vehicle_name: '2025 Artura Spider Base',
        price: '$307,990',
        mileage: '873 miles',
        vin:'SBM16BEA0SW003214',
    },
    {
        image: 'fv-img2.jpg',
        vehicle_name: '2025 Artura Base',
        price: '$284,858',
        mileage: '44 miles',
        vin:'SBM16AEA7SW003690',
    },
    {
        image: 'fv-img3.jpg',
        vehicle_name: '2023 Artura Base',
        price: '$248,770',
        mileage: '100 miles',
        vin:'SBM16AEA7PW000568',
    },
    {
        image: 'fv-img4.jpg',
        vehicle_name: '2025 GT Base',
        price: '$248,020',
        mileage: '33 miles',
        vin:'SBM22GCA5SW003337',
    },
    {
        image: 'fv-img5.jpg',
        vehicle_name: '2023 Artura Base',
        price: '$245,550',
        mileage: '4.9k miles',
        vin:'SBM16AEA2PW001160',
    },
    {
        image: 'fv-img6.jpg',
        vehicle_name: '2024 Artura',
        price: '$222,220',
        mileage: '650 miles',
        vin:'SBM16AEA6RW002203',
    },
]
const FeaturedVehicles = ({featuredVehicles, numberFormatter, priceFormatter}) => {
    UseScrollReveal();
    const isMobile = window.innerWidth <= 768;
    const visibleCars = isMobile ? featuredVehicles.slice(0, 4) : featuredVehicles.slice(0, 6);
    return (
        <>
            <section className='featured-vehicles-wrap'>
                <div className='container'>
                    <h2 className='lg-title text-uppercase text-center'>Featured Vehicles</h2>
                    <div className='featured-vehicles-block'>
                        <div className='row'>
                            {visibleCars.map((car, index) => (
                                <div className='col-lg-4 col-md-6 col-12 reveal wow fadeIn' key={index}>
                                    <article className="cs-card cs-card--2 fv-box">
                                        <div className="cs-card__img fv-top"
                                            style={{
                                                backgroundImage: `url(${car.images[0]})`,
                                            }}
                                        ></div>
                                        <Link to={"/vehicle-details/" + car.vdp_url}  className="cs-card_link">
                                            <div className="cs-card__img--hover fv-top"
                                                style={{
                                                    backgroundImage: `url(${car.images[0]})`,
                                                }}></div>
                                        </Link>
                                        <div className="fv-bottom">
                                            <div className="fv-title text-theme font-bold">{car.vehicle_name}</div>
                                            <div className="d-flex align-items-center justify-content-between mt-1">
                                                <div className="fv-price">{priceFormatter(car.price, true)}</div>
                                                <div className="fv-mileage">{numberFormatter(car.mileage)} mi</div>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FeaturedVehicles